module.exports = __webpack_public_path__ + "static/img/phones.a64a086.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/phones.png
// module id = 78z4
// module chunks = 1